document.addEventListener('DOMContentLoaded', () => {
    const linkContainers = document.querySelectorAll('.mm-header-link-container');
    let activeMenuContainer = null;

    const trapFocus = (container) => {
        const megaMenu = container.querySelector('[data-megamenu]');
        if (!megaMenu) return;

        // Use a timeout to wait for the menu to be visible after transition
        setTimeout(() => {
            const focusableElements = megaMenu.querySelectorAll(
                'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
            );

            if (focusableElements.length === 0) {
                return;
            }

            const firstFocusableElement = focusableElements[0];
            const lastFocusableElement = focusableElements[focusableElements.length - 1];

            firstFocusableElement.focus();

            const handleKeyDown = (event) => {
                if (event.key !== 'Tab') return;

                if (event.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus();
                        event.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        event.preventDefault();
                    }
                }
            };

            container.boundKeyDownHandler = handleKeyDown;
            container.addEventListener('keydown', container.boundKeyDownHandler);
        }, 100); // A small delay to allow CSS transition
    };

    const releaseFocus = (container) => {
        if (container.boundKeyDownHandler) {
            container.removeEventListener('keydown', container.boundKeyDownHandler);
            delete container.boundKeyDownHandler;
        }
        const link = container.querySelector('.mm-header-link');
        if (link) {
            setTimeout(() => link.focus(), 0);
        }
    };

    const openMenu = (container) => {
        if (activeMenuContainer && activeMenuContainer !== container) {
            closeMenu(activeMenuContainer);
        }
        const megaMenu = container.querySelector('[data-megamenu]');
        if (megaMenu) {
            megaMenu.hidden = false;
        }
        container.classList.add('focus');
        activeMenuContainer = container;
        trapFocus(container);
    };

    const closeMenu = (container) => {
        container.classList.remove('focus');
        releaseFocus(container);
        const megaMenu = container.querySelector('[data-megamenu]');
        if (megaMenu) {
            // We don't hide it, as CSS handles visibility with opacity and transform
        }
        if (activeMenuContainer === container) {
            activeMenuContainer = null;
        }
    };

    linkContainers.forEach(container => {
        const link = container.querySelector('.mm-header-link');
        const megaMenu = container.querySelector('[data-megamenu]');


        if (link && megaMenu) {
            link.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    const isExpanded = container.classList.contains('focus');
                    if (isExpanded) {
                        closeMenu(container);
                    } else {
                        openMenu(container);
                    }
                }
            });
        }
        
        container.addEventListener('mouseleave', () => {
            if (container.classList.contains('focus')) {
                closeMenu(container);
            }
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && activeMenuContainer) {
            closeMenu(activeMenuContainer);
        }
    });

    document.addEventListener('click', (event) => {
        if (activeMenuContainer && !activeMenuContainer.contains(event.target)) {
            closeMenu(activeMenuContainer);
        }
    });
});
